module.exports = __webpack_public_path__ + "static/media/imagem38.91808a57.jpeg";